import type {
  ArdoqId,
  FutureStateClaim,
  FutureStateClaimUpdate,
  FutureStateRenderClaim,
} from '@ardoq/api-types';

type UntargetedComponentClaim = Extract<
  FutureStateClaim,
  { entityType: 'component'; targetId?: null }
>;

type UntargetedComponentRenderClaim = Extract<
  FutureStateRenderClaim,
  { entityType: 'component'; targetId?: undefined }
>;

export const untargetedComponentClaimWithParentEnforced = (
  claim: UntargetedComponentClaim
): UntargetedComponentRenderClaim['assertProperties'] => ({
  ...claim.assertProperties,
  parent: claim.assertProperties.parent ?? null,
});

export const toClaimUpdate = ({
  claim,
  assertProperties,
  claimGroupId,
}: {
  claim: FutureStateClaim;
  assertProperties: Record<string, unknown> | undefined;
  claimGroupId?: ArdoqId | null;
}): FutureStateClaimUpdate => {
  const base = {
    _id: claim._id,
    _version: claim._version,
    ...(claimGroupId !== undefined ? { claimGroupId } : {}),
  };
  if (
    (claim.targetId !== null && claim.targetId !== undefined) ||
    claim.entityType !== 'component'
  ) {
    return { ...base, assertProperties };
  }

  const assertedParent = assertProperties?.parent;
  const parent =
    typeof assertedParent === 'string' || assertedParent === null
      ? assertedParent
      : claim.assertProperties.parent;

  return {
    ...base,
    assertProperties: untargetedComponentClaimWithParentEnforced({
      ...claim,
      assertProperties: {
        ...claim.assertProperties,
        ...assertProperties,
        parent,
      },
    }),
  };
};
